import React from "react";
import SchCalendarContent from "@/components/nds/windows/SchCalendarContent";

export default function CalendarTab({ resident }) {
  return (
    <div data-testid="calendar-tab" className="h-[720px] max-h-[calc(100dvh-8rem)] min-h-[480px] border border-white/10 rounded-sm overflow-hidden flex flex-col">
      <SchCalendarContent residentId={resident.id} />
    </div>
  );
}
